export class Convenente {
    id: number =  0;
    nome: string = ""
}